import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';

// System Version Logging
try {
    const { FRONTEND_VERSION } = require('./version');
    console.log(`%c[SYSTEM CHECK] %cFrontend Version: %c${FRONTEND_VERSION}`, 'color: #007bff; font-weight: bold', 'color: white', 'color: #28a745; font-weight: bold; font-size: 1.1em');

    const versionUrl = process.env.REACT_APP_ENV === 'live' ? '/v1/version' : '/dev/v1/version';

    fetch(versionUrl)
        .then(res => res.json())
        .then(data => {
            console.log(`%c[SYSTEM CHECK] %cBackend Version:  %c${data.version}`, 'color: #007bff; font-weight: bold', 'color: white', 'color: #ffc107; font-weight: bold; font-size: 1.1em');
        })
        .catch(err => console.log('Could not fetch backend version.'));
} catch (e) {
    console.log('Version tracking file not found. Run deploy script to generate it.');
}

ReactDOM.render(<App />, document.getElementById('root'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();